/*global language*/
// state
const state = () => ({
  mapAddress: null,
  mapAddressName: null,

  shippingStreet: null,
  shippingPostCode: null,
  shippingCity: null,
  shippingNote: null,
  shippingCountry: 'CH',

  areAddressesSame: true,

  pickupStreet: null,
  pickupPostCode: null,
  pickupCity: null,
  pickupNote: null,

  salutation: null,
  firstName: null,
  lastName: null,

  company: null,
  address: null,
  city: null,
  postCode: null,
  country: null,

  emailAddress: null,
  mobile: null,

  notes: null,
  swissPassCustomerID: null,
  swissPassCardID: null,
  swissPassLogin: 'No',

  acceptTermsOfService: false,
  currentLanguage: 'de',
})

// getters
const getters = {
  shippingAddress(state) {
    return `${state.shippingStreet}, ${state.shippingPostCode} ${state.shippingCity}`
  },
  pickupAddress(state, getters) {
    if (state.areAddressesSame) {
      return getters.shippingAddress
    } else {
      return `${state.pickupStreet}, ${state.pickupPostCode} ${state.pickupCity}`
    }
  },
}

// actions
const actions = {
  setAddressName({ commit }, address) {
    commit('setAddressName', address)
  },
  setMapAddress({ commit }, address) {
    commit('setMapAddress', address)
    commit('setMapAddressName', address.formatted_address)
  },
  setCurrentLanguage({ commit }) {
    commit('setCurrentLanguage', language.current)
  },
}

// mutations
const mutations = {
  pickupAddress(state, value) {
    state.pickupAddress = value
  },
  setCurrentLanguage(state, lang) {
    state.currentLanguage = lang
  },
  pickupNote(state, value) {
    state.pickupNote = value
  },
  setShippingStreet(state, street) {
    state.shippingStreet = street
  },
  setShippingPostCode(state, postCode) {
    state.shippingPostCode = postCode
  },
  setShippingCity(state, city) {
    state.shippingCity = city
  },
  setShippingNote(state, value) {
    state.shippingNote = value
  },
  setShippingCountry(state, value) {
    state.shippingCountry = value
  },
  setPickupStreet(state, street) {
    state.pickupStreet = street
  },
  setPickupPostCode(state, postCode) {
    state.pickupPostCode = postCode
  },
  setPickupCity(state, city) {
    state.pickupCity = city
  },
  setPickupNote(state, value) {
    state.pickupNote = value
  },
  setAreAddressesSame(state, value) {
    state.areAddressesSame = value
  },
  setSalutation(state, salutation) {
    state.salutation = salutation
  },
  setFirstName(state, firstName) {
    state.firstName = firstName
  },
  setLastName(state, lastName) {
    state.lastName = lastName
  },
  setCompany(state, company) {
    state.company = company
  },
  setAddress(state, address) {
    state.address = address
  },
  setCity(state, city) {
    state.city = city
  },
  setPostCode(state, code) {
    state.postCode = code
  },
  setCountry(state, country) {
    state.country = country
  },
  setEmailAddress(state, emailAddress) {
    state.emailAddress = emailAddress
  },
  setMobile(state, mobile) {
    state.mobile = mobile
  },
  setNotes(state, notes) {
    state.notes = notes
  },
  setSwissPassCustomerID(state, customerID) {
    state.swissPassCustomerID = customerID
  },
  setSwissPassCardID(state, cardID) {
    state.swissPassCardID = cardID
  },
  setSwissPassLogin(state, value) {
    state.swissPassLogin = value
  },
  setMapAddressName(state, addressName) {
    state.mapAddressName = addressName
  },
  setMapAddress(state, address) {
    state.mapAddress = address
  },
  setAcceptTermsOfService(state, value) {
    state.acceptTermsOfService = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
